import { useEffect, useRef, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaCar } from "react-icons/fa";

const Vehicledropdown = (props) => {
  const popupref = useRef(null);
  const [search, setsearch] = useState("");
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref]);

  const handlemessageChange = (event) => {
    setsearch(event.target.value);
  };
  return (
    props.visible && (
      <div
        ref={popupref}
        className={`w-[250px] ${
          props.multi == true ? "max-h-[215px]" : "max-h-[1855px]"
        }  bg-themelightblack border border-bordercolor rounded-md  gk-scr p-[10px] position absolute top-[50px] z-10  left-[0px]  self-start`}
        style={props.style}
      >
        {props.multi == true && (
          <div
            onClick={() => {
              props.data.find((x) => x.selected == false) == undefined
                ? props.bulkaction(false)
                : props.bulkaction(true);
            }}
            className={`flex flex-row items-center justify-end  w-full py-[5px] cursor-pointer text-white   hover:underline hover:text-white/80  hover:rounded-xl `}
          >
            <p className=" PoppinsRegular text-sm ml-[10px]">
              {props.data.find(
                (x) => x.selected == false || x.selected == undefined
              ) == undefined
                ? "Deselect All"
                : "Select All"}
            </p>
          </div>
        )}
        <input
          type="text"
          value={search}
          placeholder="Search"
          onChange={handlemessageChange}
          className="input px-4 text-textblack text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex mb-[10px]"
        />
        <div className="w-full overflow-y-scroll max-h-[120px]">
          {props.data.map((item, index) =>
            item.registrationnumber
              .toLowerCase()
              .includes(search.toLowerCase()) ? (
              props.assignedVehicles != undefined &&
              props.assignedVehicles.has(item?.id) ? (
                <div
                  key={index.toString()}
                  className={`flex flex-row items-center  w-full py-[5px] cursor-pointer bg-gray  text-textcolor px-[10px] rounded-xl`}
                  style={{ backgroundColor: "gray", marginBottom: 2 }}
                >
                  {/* // className={`flex flex - row items - center justify - between w - full py - [5px] cursor-pointer hover:bg-themeColor hover:text-white text-textcolor hover:rounded-xl hover:px-[10px]`}> */}
                  {item?.logo != "" && item?.logo != undefined ? (
                    <img loading="lazy"
                      src={item.logo}
                      className="w-[25px] h-[25px] rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-[25px] h-[25px] rounded-full bg-white bg-cardOverlay drop-shadow-lg  flex justify-center items-center">
                      <FaCar className="w-[50px] h-[50px] text-themeColor" />
                    </div>
                  )}
                  <p className="  PoppinsRegular text-sm ml-[10px]">
                    {item.registrationnumber}
                  </p>
                  {item.selected && (
                    <IoCheckmarkCircle className="   w-[20px] h-[20px]" />
                  )}
                </div>
              ) : (
                <div
                  key={index.toString()}
                  onClick={() => {
                    props.onClick(item, index);
                  }}
                  className={`flex flex-row items-center  w-full py-[5px] cursor-pointer hover:bg-themeblue text-white  hover:rounded-xl hover:px-[10px]`}
                >
                  {/* // className={`flex flex - row items - center justify - between w - full py - [5px] cursor-pointer hover:bg-themeColor hover:text-white text-textcolor hover:rounded-xl hover:px-[10px]`}> */}
                  {item?.logo != "" && item?.logo != undefined ? (
                    <img loading="lazy"
                      src={item.logo}
                      className="w-[25px] h-[25px] rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-[25px] h-[25px] rounded-full bg-white bg-cardOverlay drop-shadow-lg  flex justify-center items-center">
                      <FaCar className="w-[50px] h-[50px] text-themeColor" />
                    </div>
                  )}
                  <p className="  PoppinsRegular text-sm ml-[10px]">
                    {item.registrationnumber}
                  </p>
                  {item.selected && (
                    <IoCheckmarkCircle className="   w-[20px] h-[20px] text-themegreen" />
                  )}
                </div>
              )
            ) : null
          )}
        </div>
      </div>
    )
  );
};

export default Vehicledropdown;
